module.exports = __webpack_public_path__ + "img/logo-vinterior.7008ab2b.png";